export { ClipboardCheck as default } from './ClipboardCheck';
